// Single entry point for calls to the ACH Function App.
//
// Returns { data } for any JSON response, including business errors such as
// "vendor not found". Returns { unavailable: true } when the Function App cannot
// be reached: a network failure, a 502/503/504 from Front Door or the origin, or
// a body that is not JSON. Only the unavailable case should show the maintenance page.

export const API_PATH = '/api/ACHContactUpdate'
export const HEALTH_URL = process.env.REACT_APP_HEALTH_URL || '/api/health'
const ACH_FUNCTION = 'ACHContactUpdate'

// Same value the form has always sent. It ships in the bundle, so it is not a secret (see the security review).
const API_KEY = '81004d52-06fc-42a6-856d-fd55db6f14df'

const UNAVAILABLE_STATUS = [502, 503, 504]

export const callApi = async (body) => {
    let response
    try {
        response = await fetch(API_PATH, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': API_KEY,
                'X-Api-Key': API_KEY,
            },
            redirect: 'follow',
            body: JSON.stringify(body),
        })
    } catch (err) {
        return { unavailable: true }
    }

    if (UNAVAILABLE_STATUS.includes(response.status)) return { unavailable: true }

    try {
        return { data: await response.json() }
    } catch (err) {
        return { unavailable: true }
    }
}

// Health check used by the maintenance page. Resolves true only when the app is up
// and the ACH function is up. Expected body:
//   { status: "up" | "down", functions: { ACHContactUpdate: "up" | "disabled" }, time }
// The HTTP status is not trusted alone, because a disabled function can still get a 200.
// If /api/health doesn't exist yet (404), fall back to a real call against the ACH function.
// An empty vendor number is rejected by the function without touching the sheet, so it's a cheap check.
export const probeHealth = async () => {
    try {
        const res = await fetch(HEALTH_URL, { cache: 'no-store' })
        if (res.status === 404) return probeFunction()
        if (!res.ok) return false
        const health = await res.json()
        return health.status === 'up' && health.functions?.[ACH_FUNCTION] === 'up'
    } catch (err) {
        return false
    }
}

const probeFunction = async () => {
    const result = await callApi({ transactionType: 'lookupVendor', vendorNumber: '' })
    return !result.unavailable
}
